import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FrameToComeService, UserService } from '@app/core/services';
import { MatDialog } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  AppState,
  FrameToComeActionTypes,
  selectFrameToCome,
  selectFrameToComeCart,
  selectFrameToComeSearch,
} from '@app/core/ngrx';
import { State } from '@ngrx/store';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateShippingLabelComponent } from '../create-shipping-label/create-shipping-label.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneratedLabelComponent } from '../generated-label/generated-label.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'ecp-frame-to-search',
  templateUrl: './frame-to-search.component.html',
  styleUrls: ['./frame-to-search.component.scss'],
})
export class FrameToSearchComponent implements OnInit {
  theme = 'one-portal';
  public changesDetected: boolean;
  @Input() isFromDetails: boolean = false;
  @Input() frameToShipItems: any = null;
  @Output() orderDetails = new EventEmitter<any>();
  @ViewChild('cartToolTip') cartToolTip: MatTooltip;
  responseCartId: any = '';
  manageCareLabList: any = [];
  locationSelected: any = null;
  searchVal: string = '';
  selectedLab: any = null;
  frameLoading$: Observable<boolean>;
  frameForm: FormGroup;
  frame$: Observable<any>;
  cart$: Observable<any>;
  cartItem: any = [];
  cartId: any = null;
  frameSave: boolean = true;
  labelGenerate: boolean = false;
  itemExistMessage = '';
  isFrameFound: boolean = false;
  frameInfo: any;
  isSaved: boolean = false;
  rxIdVBAPattern = [Validators.required, Validators.pattern(/^[0-9]{10}$/)];
  rxIdUHCPattern = [Validators.required, Validators.pattern(/^(V[0-9a-zA-Z]{13})$/i)];
  rxIdVSPPattern = [
    Validators.required,
    Validators.pattern(
      /^(?!0{6})([0-9]{7}[1-9]|[0-9]{6}[1-9][0-9]|[0-9]{5}[1-9][0-9]{2}|[0-9]{4}[1-9][0-9]{3}|[0-9]{3}[1-9][0-9]{4}|[0-9]{2}[1-9][0-9]{5}|[0-9][1-9][0-9]{6}|[1-9][0-9]{7})$/i,
    ),
  ];
  lockDropdown:boolean = false;
  rxIdVWPattern = [
    Validators.required,
    Validators.pattern(
      /^(?!0{6})(SP[A-Za-z0-9]{5}[A-Za-z1-9]|SP[A-Za-z0-9]{4}[A-Za-z1-9][A-Za-z0-9]|SP[A-Za-z0-9]{3}[A-Za-z1-9][A-Za-z0-9]{2}|SP[A-Za-z0-9]{2}[A-Za-z1-9][A-Za-z0-9]{3}|SP[A-Za-z0-9]{1}[A-Za-z1-9][A-Za-z0-9]{4}|SP[A-Za-z1-9][A-Za-z0-9]{5}|Z[0-9]{8})$/i,
    ),
  ];
  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private frameToComeService: FrameToComeService,
    private router: Router,
  ) {
    this.frameForm = this.createFrameForm();
    this.frame$ = this.store.select(selectFrameToComeSearch);
    this.frameLoading$ = this.store.pipe(select(state => state.frameToComeSearch.pending));
    this.cart$ = this.store.select(selectFrameToCome);
    this.store.select(selectFrameToComeCart).subscribe(cartId => {
      this.cartId = cartId;
    });
  }
  frameToComeInit(){
     this.cart$.subscribe((res: any) => {
       if (res) {
         let generatedLabel = res?.trackingNumber;
         if (generatedLabel) {
           this.labelGenerate = true;
         }
         this.cartItem = res?.frameItems;
         let frameAcct = res?.frameAccountId;
         let _location = this.manageCareLabList?.managedCare.filter(r=>r.frameAccountId == frameAcct);
         if (frameAcct) {
           if (frameAcct == this.manageCareLabList?.primary?.frameAccountId) {
             this.selectedLab = 'primary';
           } else {
             this.selectedLab = 'managed_care';
             this.locationSelected = _location[0];
           }
         }
         if (this.cartItem?.length > 0) {
           this.isSaved = frameAcct ? true : false;
         } else {
           this.isSaved = false;
         }
       } else {
         this.isSaved = false;
         this.selectedLab = '';
       }
     });
     this.frame$.subscribe(search => {
       let frameRes = search;
       if (frameRes.frame?.frame) {
         this.frameInfo = frameRes.frame?.frame;
         this.frameForm.patchValue({
           upc: frameRes.search,
           brand: this.frameInfo.brand,
           style: this.frameInfo.style,
           color: this.frameInfo.color,
         });
         this.isFrameFound = true;
       } else {
         this.frameForm.reset();
         this.isFrameFound = false;
       }
     });
  }
  ngOnInit(): void {
    this.store.dispatch({
      type: FrameToComeActionTypes.SEARCH_FRAME_TO_COME,
      payload: '',
    });
    this.userService.getDropship().subscribe(dropShip => {
      this.manageCareLabList = dropShip;
      if(dropShip){
      this.frameToComeInit();
      }
    });
  }
  isValidForm() {
    return this.frameForm.invalid || this.selectedLab === '';
  }
  isToGenerate() {
    let isNew = this.selectedLab == '' || this.cartItem.length == 0;
    return this.labelGenerate || isNew;
  }
  isToSave() {
    if (this.cartItem.length !== 0) {
      let newItem = this.cartItem.filter(res => {
        return res.cartItemId == '';
      });
      if (newItem.length == 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  createFrameForm(): FormGroup {
    return this.fb.group({
      upc: new FormControl('', []),
      brand: new FormControl('', [Validators.compose([Validators.required])]),
      style: new FormControl('', [Validators.compose([Validators.required])]),
      color: new FormControl('', [Validators.compose([Validators.required])]),
      rxOrderId: new FormControl('', []),
      provider: new FormControl('', []),
      frameCondition: new FormControl(Validators.required, []),
      patientFirstName: new FormControl('', [
        Validators.compose([Validators.required, this.noWhitespaceValidator, Validators.pattern('^[A-Za-z0-9 ]+$')]),
      ]),
      patientLastName: new FormControl('', [
        Validators.compose([Validators.required, this.noWhitespaceValidator, Validators.pattern('^[A-Za-z0-9 ]+$')]),
      ]),
    });
  }
  searchUpc() {
    if (this.searchVal) {
      this.store.dispatch({
        type: FrameToComeActionTypes.SEARCH_FRAME_TO_COME,
        payload: this.searchVal,
      });
    }
  }
  isLocked(){
    return this.isSaved || this.lockDropdown || this.cartId != null;
  }
  addShippingLabel(ev: Event) {
    let frameAccId = this.manageCareLabList.primary?.frameAccountId;
    if (this.selectedLab.toLowerCase() === 'managed_care') {
      frameAccId = this.locationSelected?.frameAccountId;
    }
    if (this.isUpcAdded()) {
      this.itemExistMessage = 'Frame with same UPC and RX Order Id is already added';
      this.cartToolTip.show();
    } else {
      this.itemExistMessage = '';
      this.lockDropdown = true;
      this.store.dispatch({
        type: FrameToComeActionTypes.ADD_FRAME_TO_COME,
        payload: {
          upc: this.frameForm.get('upc').value,
          brand: this.frameForm.get('brand').value,
          style: this.frameForm.get('style').value,
          color: this.frameForm.get('color').value,
          firstName: this.frameForm.get('patientFirstName').value,
          lastName: this.frameForm.get('patientLastName').value,
          rxOrderId: this.frameForm.get('rxOrderId').value,
          frameCondition: this.frameForm.get('frameCondition').value,
          providerType: this.frameForm.get('provider').value,
          cartItemId: '',
          frameAccountId: frameAccId,
        },
      });
      this.searchVal = '';
      this.frameForm.reset();
      this.changesDetected = true;
    }
    ev.preventDefault();
  }

  saveShippingLabel() {
    let frameAccId = this.manageCareLabList.primary.frameAccountId;
    if (this.selectedLab.toLowerCase() === 'managed_care') {
      frameAccId = this.locationSelected?.frameAccountId;
    }
    let mappedCartItem = this.cartItem.filter(res => {
      return res.cartItemId === '';
    });
    let framePayload = {
      cartId: this.responseCartId || this.cartId,
      frameAccountId: frameAccId,
      frameDetails: mappedCartItem,
    };
    this.frameSave = false;
    this.orderDetails.emit(!this.frameSave);
    this.frameToComeService.addCartDetails(framePayload).subscribe(
      (res: any) => {
        this.frameSave = true;
        this.orderDetails.emit(!this.frameSave);
        this.changesDetected = false;
        if (res) {
          this.responseCartId = res.cartId;
          //localStorage.setItem('frameCartId', this.responseCartId);
          this.store.dispatch({
            type: FrameToComeActionTypes.LOAD_FRAME_TO_COME,
            payload: this.responseCartId,
          });
        }
      },
      err => {
        this.frameSave = true;
        this.orderDetails.emit(!this.frameSave);
        console.log(err);
      },
    );
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  //check if new Items are added
  saveAndGenerate() {
    if (this.cartId) {
      let mappedCartItem = this.cartItem.filter(res => {
        return res.cartItemId === '';
      });
      if (mappedCartItem.length > 0) {
        let savePromise = new Promise((resolve, reject) => {
          resolve(this.saveShippingLabel());
        });
        savePromise.then(res => {
          this.generateShippingLabel();
        });

        this.changesDetected = false;
      } else {
        this.generateShippingLabel();
        this.changesDetected = false;
      }
    } else {
      this.generateShippingLabel(false);

    }
  }
  generateShippingLabel(isFromSave:boolean = true) {
    this.frameToComeService.getLabAddressDetails().subscribe(labAddress => {
      let selectedLabData = this.manageCareLabList.primary;
      if (this.selectedLab.toLowerCase() === 'managed_care') {
        selectedLabData = this.locationSelected;
      }
      let shippingData = {
        labLocation: labAddress,
        selectedLab: selectedLabData,
      };
      let shippingDialog = this.dialog.open(CreateShippingLabelComponent, {
        width: '600px',
        maxWidth: '89.3vw',
        maxHeight: '82vh',
        data: shippingData,
        disableClose: true,
      });
      shippingDialog.afterClosed().subscribe((result: any) => {
        if (result) {
          if(!isFromSave){
            let frameAccId = this.manageCareLabList?.primary?.frameAccountId;
            if (this.selectedLab.toLowerCase() === 'managed_care') {
              frameAccId = this.locationSelected?.frameAccountId;
            }
            let framePayload = {
              cartId: this.responseCartId,
              frameAccountId: frameAccId,
              frameDetails: this.cartItem,
            };
            this.frameToComeService.addCartDetails(framePayload).subscribe((frame: any) => {
              this.cartId = frame.cartId;
              let generatePayload = { ...result, cartId: this.cartId };
              this.generateLabelService(generatePayload);
            });
            this.changesDetected = false;
          }else{
            let responseId = this.cartId;
            if(!responseId){
              responseId = this.responseCartId;
            }
            let generatePayload = { ...result, cartId: responseId };
            this.generateLabelService(generatePayload);
          }
        }
      });
    });
  }

  generateLabelService(pl: any = null) {
    let generateDialog = this.dialog
      .open(GeneratedLabelComponent, {
        width: '600px',
        maxWidth: '89.3vw',
        height: '80%',
        data: pl,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((gen: any) => {
        if (gen) {
          //localStorage.removeItem('frameCartId');
          this.router.navigateByUrl('/frame-to-come/track-shipment');
        }
      });
  }

  isUpcAdded() {
    let upc = this.frameForm.get('upc').value;
    let rxOrderId = this.frameForm.get('rxOrderId').value;
    let isExist = this.cartItem.filter(res => {
      return res.upc === upc && res.rxOrderId === rxOrderId;
    });
    if (isExist.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  changeRxOrderIdPattern() {
    switch (this.frameForm.controls['provider'].value) {
      case 'eyemed':
      case 'privatepay':
      case 'versant': {
        this.frameForm.controls['rxOrderId'].setValidators(this.rxIdVWPattern.concat(Validators.required));
        break;
      }
      case 'vsp': {
        this.frameForm.controls['rxOrderId'].setValidators(this.rxIdVSPPattern.concat(Validators.required));
        break;
      }
      case 'uhc': {
        this.frameForm.controls['rxOrderId'].setValidators(this.rxIdUHCPattern.concat(Validators.required));
        break;
      }
      case 'vba': {
        this.frameForm.controls['rxOrderId'].setValidators(this.rxIdVBAPattern.concat(Validators.required));
        break;
      }
    }
    this.frameForm.get('rxOrderId').updateValueAndValidity();
  }
  ngOnDestroy() {
    this.selectedLab = '';
    this.locationSelected = '';
    this.frameForm.reset();
    this.store.dispatch({type: FrameToComeActionTypes.CLEAR_FRAME_TO_COME});
  }
}
